import { Navigate, useParams } from "react-router-dom";
import usePageTitle from "@/hooks/usePageTitle";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import MobileActivityTypeLandingPage from "./MobileActivityTypeLandingPage";

export default function ActivityTypeIndexPage() {
  usePageTitle("/activities/activity-types/:activityTypeId", "Activities | Activity Type Details");
  const { activityTypeId = "" } = useParams();
  const { isCompactLayout: isMobile } = useIsCompactLayout();

  // Show mobile landing page for mobile devices
  if (isMobile) {
    return <MobileActivityTypeLandingPage />;
  }

  // Redirect to activities for desktop
  return <Navigate to={`/activities/activity-types/${activityTypeId}/activities`} replace />;
}
